import { useQuery } from "@tanstack/react-query";
import { Table } from "antd";
import { queryKeys } from "api/master";
import usePagination from "hooks/usePagination";
import { useState } from "react";
import { MEMBER_ATTENDED_TAB_ACTIVE_KEY } from "common/common";
import { cn } from "libs/classnames";

const SurveyAnswersHistory = ({ tabActiveKey, memberId }) => {
	const { pagination, setPaginationTotal, setPaginationPage } = usePagination({
		initialSortKey: "surveyId",
		initialPerPage: 10,
	});
	const [surveyAnswers, setSurveyAnswers] = useState([]);

	useQuery({
		...queryKeys.members.listOfSurveyAnswerHistories({
			pp: pagination.perPage,
			p: pagination.page,
			sort: pagination.sort,
			sortKey: pagination.sortKey,
			memberId,
		}),
		onSuccess: async (response) => {
			setPaginationTotal(response.count || 0);
			setSurveyAnswers(response.rows);
		},
		enabled:
			tabActiveKey === MEMBER_ATTENDED_TAB_ACTIVE_KEY.SURVEY_ANSWERS &&
			!!memberId,
	});

	return (
		<Table
			bordered
			size="small"
			rowKey="id"
			dataSource={surveyAnswers}
			className={cn(
				"[&_.ant-table-wrapper]:max-h-[60vh]",
				"[&_.ant-table-container]:max-h-[50vh]",
				"[&_.ant-table-container]:overflow-y-scroll",
				"[&_.ant-table-content]:min-w-[560px]",
			)}
			columns={[
				{
					title: "アンケートID",
					key: "surveyId",
					dataIndex: "surveyId",
				},
				{
					title: "アンケート回答番号",
					key: "surveyRewardCode",
					dataIndex: "surveyRewardCode",
				},
				{
					title: "アンケート名",
					key: "surveyName",
					dataIndex: "surveyName",
				},
			]}
			pagination={{
				current: pagination.page,
				total: pagination.total,
				onChange: setPaginationPage,
				pageSize: pagination.perPage,
			}}
		/>
	);
};

export default SurveyAnswersHistory;
